module.exports = __webpack_public_path__ + "images/hero-talent-pool.jpg";